import Store from 'store/store'
import { Component } from 'utils/jsx'

export default class Modal extends Component {
  beforeRender (props) {
    this.destroy = this.destroy.bind(this)
    this.captureEscapeKey = this.captureEscapeKey.bind(this)
  }

  template (props) {
    return (
      <section class='modal-wrapper' event-click={this.destroy}>
        <div class='modal' event-click={e => e.stopPropagation()}>
          <header class='modal__header'>
            {props.title.split('\n').map(line => (<div>{line}</div>))}
          </header>
          <div class='modal__content' ref={this.ref('content')}>
            {props.children}
          </div>
        </div>
      </section>
    )
  }

  afterRender () {
    Store.hasOpenModal.set(true)
    window.addEventListener('keyup', this.captureEscapeKey)
  }

  afterMount () {
    const active = this.refs.content.querySelector('.is-active')
    active && active.scrollIntoView(true)
  }

  captureEscapeKey (e) {
    if (e.key !== 'Escape') return
    this.destroy()
  }

  beforeDestroy () {
    Store.hasOpenModal.set(false)
    window.removeEventListener('keyup', this.captureEscapeKey)
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.js